/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect, useLayoutEffect } from 'react';
import './StudentForm.css';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions/';
import { getStudent } from '@/app/services/students/students';
import dayjs from 'dayjs';
import { getAgeDetails } from '@/utils/utils';
import JWTService from '@/app/services/jwtService';
import axios from '@shared/axios-shared';
import StudentView from '@/app/fuse-layouts/shared-components/student-form/StudentView';
import MedicalView from '@/app/fuse-layouts/shared-components/student-form/MedicalView';
import ImmunizationView from '@/app/fuse-layouts/shared-components/student-form/ImmunizationView';
import RoomAttachmentsView from '@/app/fuse-layouts/shared-components/student-form/RoomAttachmentsView';
import ContactView from '@/app/fuse-layouts/shared-components/student-form/ContactView';
import TopProgress from '@/app/fuse-layouts/shared-components/student-form/TopProgress';
import { useNavigate, useLocation } from 'react-router-dom';

const StudentInformation = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const [student, setStudent] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [currentState, setCurrentState] = useState(location.state?.tab || 'personal');
	const [refresh, setRefresh] = useState(0);
	const [age, setAge] = useState('');
	const token = location.search.split('=')[1];
	const navigate = useNavigate();
	useLayoutEffect(() => {
		JWTService.setSession(null);
	}, []);

	useEffect(() => {
		if (token) {
			axios
				.post('api/v1/parent/token', { token: `${token}==` })
				.then((res) => {
					JWTService.setSession(res.data.token);
					getStudent(res.data.student_id)
						.then((response) => {
							setStudent(response?.data);
							setIsLoading(false);
						})
						.catch(() => {
							setIsLoading(false);
						});
				})
				.catch((err) => {
					if (err.response.data.message) {
						navigate({ pathname: '/expiredlink' });
					} else {
						dispatch(Actions.showMessage({ variant: 'error', message: 'Invalid token' }));
						navigate({ pathname: '/login' });
					}
				});
		} else {
			dispatch(Actions.showMessage({ variant: 'error', message: 'Invalid token' }));
			setTimeout(() => {
				navigate({ pathname: '/login' });
			}, 1000);
		}
	}, [refresh]);

	useEffect(() => {
		if (student) {
			setAge(getAgeDetails(dayjs(student?.date_of_birth), dayjs()));
		}
	}, [student]);

	return (
		<>
			<TopProgress currentState={currentState} setCurrentState={setCurrentState} />
			<div className="mt-64 mx-auto" style={{ width: '75%' }}>
				{currentState === 'personal' ? (
					<StudentView isLoading={isLoading} setCurrentState={setCurrentState} student={student} token={`${token}==`} />
				) : null}
				{currentState === 'medication' ? (
					<MedicalView isLoading={isLoading} setCurrentState={setCurrentState} student={student} token={`${token}==`} />
				) : null}
				{currentState === 'room-attachments' ? (
					<RoomAttachmentsView
						isLoading={isLoading}
						refresh={refresh}
						setCurrentState={setCurrentState}
						setRefresh={setRefresh}
						setStudent={setStudent}
						student={student}
					/>
				) : null}
				{currentState === 'contacts' ? (
					<ContactView isLoading={isLoading} setCurrentState={setCurrentState} student={student} token={`${token}==`} />
				) : null}
				{currentState === 'immunizations' ? (
					<ImmunizationView
						age={age}
						isLoading={isLoading}
						refresh={refresh}
						setCurrentState={setCurrentState}
						setRefresh={setRefresh}
						student={student}
						token={`${token}==`}
					/>
				) : null}
			</div>
		</>
	);
};

export default StudentInformation;
